// extracted by mini-css-extract-plugin
export var container = "_6n-0";
export var infoButton = "_6n-1";
export var label = "_6n-3";
export var labelExpanded = "_6n-4";
export var price = "_6n-5";
export var priceExpanded = "_6n-6";
export var title = "_6n-2";